// extracted by mini-css-extract-plugin
export var createdDate = "_nq-1";
export var divider = "_nq-2";
export var headerDivider = "_nq-3";
export var messagesCard = "_nq-0";
export var messagesContainer = "_nq-6";
export var messagesContainerWrapper = "_nq-4";
export var showLeftPanelButton = "_nq-8";
export var topButtons = "_nq-7";
export var withPadding = "_nq-5";